module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/feature_01-358aa8edaaa631b2b9f142699859db54.png";